// Intent: [Conversion] [Journey] [SEO/GEO]
import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { IMAGE_ASSETS } from "../../config";
const categories = [{
  title: "Kitchens",
  image: IMAGE_ASSETS.kitchenCategory
}, {
  title: "Laundries",
  image: IMAGE_ASSETS.laundryCategory
}, {
  title: "Wardrobes",
  image: IMAGE_ASSETS.wardrobeCategory
}, {
  title: "Vanities",
  image: IMAGE_ASSETS.vanityCategory
}] as const;
function CabinetryCategories() {
  return <section id="cabinetry" className="section-shell bg-[#eceae4]" aria-labelledby="categories-title" data-id="element-99" data-mp="3kut1qkx7k853">
      <div className="container-shell" data-id="element-100" data-mp="3tto5zrgoz85r">
        <p className="section-label text-center text-pfpc-steel" data-id="element-101" data-mp="3tsliltikvnul">Explore</p>
        <h2 id="categories-title" className="mx-auto mt-2 max-w-2xl text-center font-heading text-[28px] font-extrabold leading-[1.15] text-pfpc-navy md:text-[34px]" data-id="element-102" data-mp="3ou1txlclnxyj">
          Cabinetry for the rooms you are planning.
        </h2>
        <div className="mt-7 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-103" data-mp="1uhu2wj3eg181">
          {categories.map(({
          title,
          image
        }) => <a key={title} href="/cabinetry/" data-analytics="shop_category_clicked" className="group relative block aspect-[4/3] overflow-hidden rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pfpc-orange focus-visible:ring-offset-2" data-id="element-104" data-mp="3t7tmrfyxw03k">
              <img src={image} alt={`${title} cabinetry`} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-105" data-mp="fva0p7qfjbfc" />
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-pfpc-navy/85 px-4 py-3" data-id="element-106" data-mp="pt7pbwc7ba8h">
                <span className="font-heading text-[15px] font-extrabold text-pfpc-offwhite" data-id="element-107" data-mp="usu2k5s14qha">{title}</span>
                <ArrowRightIcon className="h-4 w-4 text-pfpc-orange transition-transform duration-200 group-hover:translate-x-1" data-id="element-108" data-mp="2rlcfb2a53xgk" />
              </div>
            </a>)}
        </div>
        <p className="mt-5 text-center text-[14px] text-pfpc-navy/68" data-id="element-109" data-mp="2oig0xkn7pxkf">
          Need doors, panels or hardware? <a href="/cabinetry/" className="font-bold text-pfpc-navy underline decoration-pfpc-orange underline-offset-4" data-id="element-110" data-mp="2jko90qmkibg8">View all cabinetry options.</a>
          <span className="ml-2 text-[11px] text-pfpc-navy/45" data-id="element-111" data-mp="2yf2le8bmmmlx">Imagery is illustrative.</span>
        </p>
      </div>
    </section>;
}
export { CabinetryCategories };